export default __webpack_public_path__ + "static/media/room.949aa917.jpg";